

// Imports ---------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component Properties ----------------------------------------------------

    props: {
        icon: {
            type: String,
            required: false,
            default: ""
        }
    },

    // Component Computed Properties -------------------------------------------

    computed: {
        hasIcon (): boolean {
            return !!this.icon;
        },

        iconClasses (): string {
            return `las la-${this.icon}`;
        }
    }

    // -------------------------------------------------------------------------
});

